<template lang="pug">
el-form-item.admin-form-full-width-field(
  :id="fieldElementId",
  :label="label",
  :prop="prop",
  :required="required",
  :for="controlId",
  :error="fieldError || undefined"
)
  slot(
    :aria-describedby="ariaDescribedby",
    :aria-invalid="Boolean(fieldError)",
    :aria-required="required",
    :disabled="fieldDisabled"
  )
  template(#error="{ error }")
    .el-form-item__error(:id="errorId") {{ error }}
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import { adminFormContextKey } from "./types";

const props = withDefaults(
  defineProps<{
    label?: string;
    prop: string;
    controlId?: string;
    required?: boolean;
    error?: string;
    disabled?: boolean;
  }>(),
  {
    label: undefined,
    controlId: undefined,
    required: false,
    error: undefined,
    disabled: false,
  },
);

const formContext = inject(adminFormContextKey, undefined);

const fieldError = computed(
  () => props.error ?? formContext?.externalErrors.value[props.prop],
);
const fieldDisabled = computed(
  () => props.disabled || formContext?.disabled.value === true,
);
const fieldElementId = computed(
  () => `admin-form-field-${props.prop.replaceAll(/[^a-zA-Z0-9_-]/g, "-")}`,
);
const errorId = computed(() => `${fieldElementId.value}-error`);
const ariaDescribedby = computed(() =>
  fieldError.value ? errorId.value : undefined,
);
</script>

<style scoped>
.admin-form-full-width-field {
  grid-column: 1 / -1;
  margin: 0;
  min-width: 0;
}

.admin-form-full-width-field :deep(.el-form-item__content) {
  display: block;
  line-height: inherit;
  margin-left: 0 !important;
  min-height: 0;
  min-width: 0;
}

.admin-form-full-width-field :deep(.el-form-item__error) {
  box-sizing: border-box;
  contain: inline-size;
  max-inline-size: 100%;
  min-inline-size: 0;
  overflow-wrap: anywhere;
  padding-top: 0.25rem;
  position: static;
}
</style>
